<template>
    <div class="home">
        <banner type="1"></banner>
        <div class="w-1200 mt-100" style="padding-bottom: 160px;">
            <div class="text-center font-24 font-500">About us</div>
            <div class="text-center mt-6 font-500">HUAPUA：A bio-tech enterprise providing R&D, application and technical
                services of diagnostic materials.
            </div>
            <div class="text-center mt-2 font-500">Technology platforms: antibody and antigen preparations platform,
                molecular materials platform, supplementary materials platform and reagents development technology
                platform.
            </div>
            <div class="text-center mt-150 font-24 font-500">About products</div>
            <div class="text-center mt-6">to improve the quality of in vitro diagnostic industry, reduce costs and
                enhance the market competitivenesses of core materials products in china through our own brand
                characteristics and advantages.
            </div>
            <div class="mt-50 flex font-500 flex-wrap productNavBox">
                <div class="productNav" v-for="item in productCate" :key="item.id"
                     @click="$router.push(`/pc-en/product-center?id=${item.id}&name=${item.name}`)">
                    <img :src="item.pic" alt="">
                    <div>{{item.name}}</div>
                </div>
            </div>
            <div class="flex flex-j-c flex-a-c mt-8" @click="$router.push('/pc-en/pets')">
                <img src="../assets/img/congwu.png" width="166" height="180" alt="">
                <div class="ml-8 font-500 font-24 color-red">Pet diagnosis</div>
            </div>
        </div>
        <div class="w-1200 bgc-gray BFC">
            <div class="text-center font-24 mt-100 font-500">Custom services</div>
            <div class="text-center mt-6"> Do you have any unsolvable confusions during daily diagnostic products
                development ?
                If so,we will help you figure out with them.
            </div>
            <div class="flex font-18" style="margin-top: 80px;">
                <img src="../assets/img/dingzifuwu.jpg" width="320" height="500" alt="">
                <div class="customizedServicesTextBox ml-8">
                    <div>
                        HUAPUA is able to provide you with semi-finished/finished kits development/custom services,based
                        on more than a decade of products and technical services experiences in in vitro diagnosis.
                    </div>
                    <div class="mt-6">
                        An expert in the design of small molecular derivatives: transform or synthesize derivatives of
                        small molecular compounds and provide semi-antigen derivatives for your needs.
                    </div>
                    <div class="mt-6">
                        IF you use huapua prepared kits,we will offer technical supports based on your requirements for
                        free.besides,we will trace the whole experimental progresses for solving relevant problems in
                        time.
                    </div>
                    <div class="font-600 color-red mt-6"
                         @click="$router.push(`/pc-en/customized-services`)">Please click to check more>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-1200" style="padding: 145px 0 200px;">
            <div class="text-center font-500 font-24">Superior products recommedation</div>
            <div class="recommendBox flex flex-wrap mt-50">
                <div class="recommend" v-for="item in recommendCate" :key="item.id"
                     @click="$router.push({
                    path:'/pc-en/recommend',
                    query:{
                    id:item.id,
                    name:item.name
                    }
                })">
                    <img :src="item.pic" alt="">
                    <div class="text-center font-500 font-20 mt-4">{{item.name}}
                        <img src="../assets/img/add.png" width="18" height="18" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'home',
        components: {},
        data() {
            return {
                productCate: [],
                banner: [],
                recommendCate: []
            }
        },
        async mounted() {
            this.getProductCate()
            this.getRecommendCate()
        },
        methods: {
            // 获取首页产品
            async getProductCate() {
                this.productCate = await this.$api.getProductCate({top: 1})
            },
            //    获取首页优品推荐
            async getRecommendCate() {
                this.recommendCate = await this.$api.getRecommendCate({top: 1})
            }
        }
    }
</script>
<style scoped lang="scss">
    .productNavBox {
        .productNav {
            width: 224px;
            height: 300px;
            background: #BD2C2E;
            padding: 50px 35px 30px;
            color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 20px;

            &:nth-child(5n+1) {
                margin-left: 0;
            }

            &:nth-child(n+6) {
                margin-top: 20px;
            }

            img {
                width: 120px;
                height: 120px;
            }

            div {
                height: 91px;
                width: 154px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
            }
        }
    }

    .recommendBox {
        .recommend {
            margin-left: 20px;

            &:nth-child(3n+1) {
                margin-left: 0;
            }

            &:nth-child(n+4) {
                margin-top: 20px;
            }

            & > img {
                width: 380px;
                height: 300px;
            }
        }
    }

    .customizedServicesTextBox {
        padding: 24px 50px;
        background-color: #fff;
        position: relative;

        div {
            line-height: 45px;
        }

        .san {
            position: absolute;
            left: -20px;
            top: 70px;
            width: 0px;
            height: 0px;
            border-top: 20px solid transparent;
            border-right: 20px solid #fff;
            border-bottom: 20px solid transparent;
            z-index: 1;
        }
    }
</style>
